import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
export const addNewBannerFunc = createAsyncThunk(
  "addBanner",
  async ({ data }, thunkAPI) => {
    try {
      const res = await api.post(`dashboard/general-settings/banners`, data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const addNewBannerSlicer = createSlice({
  name: "addBanner",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addNewBannerFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(addNewBannerFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(addNewBannerFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});
export default addNewBannerSlicer.reducer;
